import styled from 'styled-components'
import { useCallback, useMemo } from 'react'
import { useTranslation } from 'next-i18next'

import { DateAndTime as DateAndTimeBase } from './DateAndTime'
import { colors, fontWeights } from '../../../utils'

const EventDateContainer = styled.div`
  display: flex;
  align-items: center;
`

const DateAndTime = styled(DateAndTimeBase)`
  text-transform: uppercase;
  .dateAndTime {
    font-weight: ${fontWeights.medium};
    color: ${colors.purple};
  }
`
export const HeaderDateTime: React.FC<
  React.ComponentProps<typeof DateAndTimeBase> & {
    className?: string
  }
> = ({ className = '', ...props }) => {
  const { t } = useTranslation('common')
  const isUpcoming = useMemo(
    () => new Date(props.dateTime).getTime() - new Date().getTime() > 0,
    [props.dateTime],
  )

  const getDisplayTime = useCallback(
    (dateText: string, timeText: string) => {
      const dateTime = `${dateText} at ${timeText}`

      const suffix = isUpcoming ? `${t('Upcoming', 'Upcoming')}: ` : ''
      return `${suffix}${dateTime}`
    },
    [isUpcoming, t],
  )

  return (
    <EventDateContainer className={className}>
      <DateAndTime {...props} getDisplayTime={getDisplayTime} />
    </EventDateContainer>
  )
}
